import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footer-bar p-0" };
const _hoisted_2 = { class: "container-fluid" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = {
    class: "container",
    style: { "padding-top": "25px" }
};
const _hoisted_5 = { class: "row text-muted" };
const _hoisted_6 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12 col-md-6 col-xl-3\"><h3 class=\"elementor-heading-title elementor-size-large\">Adresse</h3><p>Suchy Messtechnik<br>Garnsdorfer Hauptstraße 116<br>09244 Lichtenau</p></div><div class=\"col-12 col-md-6 col-xl-3\"><h3 class=\"elementor-heading-title elementor-size-large\">Kontakt</h3><p>info@suchy-messtechnik.de<br>Telefon: +49 37208 8842-0<br>Fax: +49 37208 8842-12</p></div><div class=\"col-12 col-md-6 col-xl-3\"><h3 class=\"elementor-heading-title elementor-size-large\">Öffnungszeiten</h3><p>Mo – Do: 7 – 16:30 Uhr<br>Fr: 7 – 14 Uhr</p></div>", 3);
const _hoisted_9 = { class: "col-12 col-md-6 col-xl-3 position-relative" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("h3", { class: "elementor-heading-title elementor-size-large" }, "Info", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_12 = { class: "d-none d-sm-block scroll-to-top" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/themes/suchy/scroll-up-website-suchy-messtechnik.png",
    alt: "Nach oben"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createStaticVNode("<div class=\"row bar2\"><div class=\"container\"><div class=\"row text-muted\"><div class=\"col pt-1 pb-1\"><a href=\"https://august-stark.de/\" target=\"_blank\">Website &amp; Design by August Stark</a></div></div></div></div>", 1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("p", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerMenuEntriesRight, (menuItem) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"]),
                                        _hoisted_11
                                    ], 64));
                                }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_g_link, { onLinkClick: _ctx.scrollToTop }, {
                                    default: _withCtx(() => [
                                        _hoisted_13
                                    ]),
                                    _: 1
                                }, 8, ["onLinkClick"])
                            ])
                        ])
                    ])
                ])
            ]),
            _hoisted_14
        ])
    ]));
}
